import { render, staticRenderFns } from "./checklist-input-switch.vue?vue&type=template&id=7c2ab5f4&"
import script from "./checklist-input-switch.vue?vue&type=script&lang=js&"
export * from "./checklist-input-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports